<innogy-box [hideFirstBorder]="hideFirstBorder">
  <innogy-box-headline>
    <eop-loading-results
      [label]="'HEADER.RECEIPTS'"
      [count]="totalItems"
      [loading]="searchInProgress">
    </eop-loading-results>
  </innogy-box-headline>
  <div custom-info-box-header-content>
    <eop-dropdown-button
      [defaultLabel]="'GLOBAL.DOWNLOAD' | translate"
      [options]="createOptions"
      [disabled]="
        totalItems === 0 ||
        (exportLimitExceeded &&
          ((!filter.sessionStartFrom && !filter.sessionStartTo) || exportTimeLimitExceeded)) ||
        zipGenerationInProgress ||
        searchInProgress
      "
      [matTooltip]="
        exportLimitExceeded &&
        ((!filter.sessionStartFrom && !filter.sessionStartTo) || exportTimeLimitExceeded)
          ? ('RECEIPTS.EXPORT_LIMIT' | translate)
          : zipGenerationInProgress
            ? ('RECEIPTS.DOWNLOAD_WIP' | translate)
            : null
      "
      [noDefault]="true"
      [dataTestId]="'download-dropdown-button'"
      [inProgress]="excelDownloadInProgress || zipDownloadInProgress"
      (optionSelected)="onDownloadOption($event)"></eop-dropdown-button>
  </div>
  @if (!!selectedPartnerItem) {
    <div>
      <eop-filter
        [hideAddressFilter]="true"
        [specificFiltersConfig]="filterComponents"
        (filter)="onFilter($event)">
      </eop-filter>

      <app-innogy-data-table
        [tableConfig]="tableConfig"
        [dataSource]="result"
        [loadingData]="searchInProgress"
        (requireNewData)="requireNewData($event)"
        (sortData)="orderByColumn($event)"
        (dynamicCellButtonClick)="onDownload($event)">
      </app-innogy-data-table>
    </div>
  } @else {
    @if (!searchInProgress) {
      <eop-image-placeholder
        iconName="briefcase-outlined"
        [text]="'GLOBAL.PLEASE_SELECT_PROVIDER' | translate">
      </eop-image-placeholder>
    }
  }
</innogy-box>
